import { MaterialIcon } from '@qred/components-library';
import React from 'react';
import { Bullet } from '../VerticalTimeline.styled';
import { BADGE_COLOR_GREY_800, BADGE_COLOR_PRIMARY_800 } from './constants';

type IconProps = {
  isLastItem: boolean;
  isCompleted: boolean;
};
const Icon = ({ isLastItem, isCompleted }: IconProps): React.JSX.Element => {
  if (isLastItem) {
    return (
      <MaterialIcon
        src="new_releases"
        color={isCompleted ? BADGE_COLOR_PRIMARY_800 : BADGE_COLOR_GREY_800}
        size={24}
      />
    );
  }

  if (isCompleted) {
    return (
      <MaterialIcon
        src="check_circle"
        color="Main/Primary/800"
        filled
        size={24}
      />
    );
  }

  return <Bullet bg="Text/Secondary" />;
};

export default Icon;
